import * as React from "react";
import { Input } from "antd";

type Props = {
    value: string;
    label: string;
};

export const ActivationTimeBox = ({value, label}: Props) => {
  return (
    <>
      <Input value={value} readOnly />
      <label>{label}</label>
    </>
  );
};
